import React from "react";
import axios from "axios";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { StyledCol, StyledTableRow } from "../../../styles/styledTable";
import { StyledBreakWord } from "../../../styles/styledBreakWord";
import { StyledCopy } from "../../../styles/styledCopy";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import MaterialSwitch from "../../../styles/materialSwitch";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";

const TelegramChatsItem = ({ chat, onToggled, setNotification, t }) => {
  const handleToggle = () => {
    axios.patch(`/api/telegram/chats/${chat.id}/toggle-active`, {}, userAuthenticationConfig())
      .then(response => {
        if (response.status === 200) onToggled(response.data);
      })
      .catch(error => {
        setNotification({ visible: true, type: "error", message: error?.response?.data?.message || t("chats.errors.toggleActive") });
      });
  };

  return (
    <StyledTableRow scroll="auto" col="6" className="chat-list__row">
      <StyledCol data-title={t("chats.table.status")}>
        <MaterialSwitch
          checked={chat.isActive}
          onChange={handleToggle}
          label={t("chats.table.status")}
        />
      </StyledCol>
      <StyledCol data-title={t("chats.table.id")}>
        {chat.id}
      </StyledCol>
      <StyledCol data-title={t("chats.table.telegramChatId")}>
        <CopyToClipboard
          text={String(chat.telegramChatId)}
          onCopy={() => setNotification({ visible: true, type: "success", message: t("common.copied") })}
        >
          <StyledBreakWord as="p">
            {chat.telegramChatId} <StyledCopy title={t("common.copy")} className="icon-light-copy" />
          </StyledBreakWord>
        </CopyToClipboard>
      </StyledCol>
      <StyledCol data-title={t("chats.table.title")}>
        {chat.title || "--"}
      </StyledCol>
      <StyledCol data-title={t("chats.table.project")}>
        {chat.projectName || "--"}
      </StyledCol>
      <StyledCol data-title={t("chats.table.createdAt")}>
        {TimestampToDateMoment(chat.createdAt)}
      </StyledCol>
    </StyledTableRow>
  );
};

export default TelegramChatsItem;
